/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import React from 'react';

interface AIIconProps {
  width?: string | number;
  height?: string | number;
}

const AIIcon: React.FC<AIIconProps> = ({ width = '26', height = '26' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 26 26"
      fill="none"
      style={{ display: 'block', width: '100%', height: '100%' }}
    >
      <path
        d="M24.375 13.0227C21.4235 13.204 18.6401 14.4582 16.5491 16.5491C14.4582 18.6401 13.204 21.4235 13.0227 24.375H12.9773C12.7964 21.4234 11.5423 18.6398 9.45124 16.5488C7.36021 14.4577 4.57663 13.2036 1.625 13.0227V12.9773C4.57663 12.7964 7.36021 11.5423 9.45124 9.45124C11.5423 7.36021 12.7964 4.57663 12.9773 1.625H13.0227C13.204 4.57651 14.4582 7.35989 16.5491 9.45086C18.6401 11.5418 21.4235 12.796 24.375 12.9773V13.0227Z"
        fill="#90E7FF"
      />
      <path
        d="M4.85417 7.20833C5.60205 7.20833 6.20833 6.60205 6.20833 5.85417C6.20833 5.10628 5.60205 4.5 4.85417 4.5C4.10628 4.5 3.5 5.10628 3.5 5.85417C3.5 6.60205 4.10628 7.20833 4.85417 7.20833Z"
        fill="#90E7FF"
      />
      <path
        d="M20.8542 21.7083C21.6021 21.7083 22.2083 21.1021 22.2083 20.3542C22.2083 19.6063 21.6021 19 20.8542 19C20.1063 19 19.5 19.6063 19.5 20.3542C19.5 21.1021 20.1063 21.7083 20.8542 21.7083Z"
        fill="#90E7FF"
      />
    </svg>
  );
};

export default AIIcon;
